const WISHLIST_STORAGE_KEY = 'wishlist';

const WISHLIST_ICON_OUTLINE = `<svg class="wishlist-button__icon" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M16.5 4.5c2.206 0 4 1.794 4 4 0 4.67-5.543 8.94-8.5 11.023C9.043 17.44 3.5 13.17 3.5 8.5c0-2.206 1.794-4 4-4 1.298 0 2.522.638 3.273 1.706L12 7.953l1.227-1.746c.75-1.07 1.975-1.707 3.273-1.707m0-1.5c-1.862 0-3.505.928-4.5 2.344C11.005 3.928 9.362 3 7.5 3 4.462 3 2 5.462 2 8.5c0 5.72 6.5 10.438 10 12.85 3.5-2.412 10-7.13 10-12.85C22 5.462 19.538 3 16.5 3z" fill="currentColor"/></svg>`;

const WISHLIST_ICON_FILLED = `<svg class="wishlist-button__icon" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="currentColor"/></svg>`;

function isValidWishlistItem(item) {
  if (!item || typeof item !== 'object') return false;

  const title = String(item.productTitle || '');
  const url = String(item.productUrl || '');

  if (!title || !url) return false;
  if (title.includes('{{') || title.includes('{%')) return false;
  if (url.includes('{{') || url.includes('{%')) return false;

  return true;
}

function getWishlist() {
  try {
    const raw = JSON.parse(localStorage.getItem(WISHLIST_STORAGE_KEY)) || [];
    const valid = raw.filter(isValidWishlistItem);

    if (valid.length !== raw.length) {
      localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(valid));
    }

    return valid;
  } catch (error) {
    return [];
  }
}

function saveWishlist(items) {
  localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(items));
}

function itemKey(item) {
  return String(item.productId || item.productTitle || '');
}

function getProductDataFromButton(button) {
  if (!button) return null;

  return {
    productId: button.dataset.productId || '',
    productTitle: button.dataset.productTitle || '',
    productImg: button.dataset.productImg || '',
    productPrice: button.dataset.productPrice || '',
    productUrl: button.dataset.productUrl || '',
  };
}

function escapeHtml(text) {
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

const WISHLIST_ACTIVE_COLOR = '#e11d48';

function updateWishlistButtonState(button) {
  if (!button) return;

  const data = getProductDataFromButton(button);
  if (!data || !isValidWishlistItem(data)) return;

  const isActive = getWishlist().some((item) => itemKey(item) === itemKey(data));

  button.classList.toggle('is-active', isActive);
  button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  button.innerHTML = isActive ? WISHLIST_ICON_FILLED : WISHLIST_ICON_OUTLINE;
  button.style.color = isActive ? WISHLIST_ACTIVE_COLOR : '';
}

function refreshAllWishlistButtons() {
  document.querySelectorAll('.wishlist_button').forEach(updateWishlistButtonState);
}

function updateWishlistCount() {
  const count = getWishlist().length;
  document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
    el.textContent = count > 99 ? '99+' : String(count);
    el.toggleAttribute('hidden', count === 0);
  });
}

function toggleWishlist(button) {
  const trigger = button || document.querySelector('.wishlist_button');
  if (!trigger) return;

  const productData = getProductDataFromButton(trigger);
  if (!productData || !isValidWishlistItem(productData)) return;

  const key = itemKey(productData);
  let wishlistData = getWishlist();
  const exists = wishlistData.some((item) => itemKey(item) === key);

  if (exists) {
    wishlistData = wishlistData.filter((item) => itemKey(item) !== key);
  } else {
    wishlistData.push(productData);
  }

  saveWishlist(wishlistData);
  updateWishlistButtonState(trigger);
  updateWishlistCount();
  displayWishlist();
}

function removeFromWishlist(key) {
  const wishlistData = getWishlist().filter((item) => itemKey(item) !== key);
  saveWishlist(wishlistData);
  updateWishlistCount();
  displayWishlist();

  const button = document.querySelector('.wishlist_button');
  if (button && itemKey(getProductDataFromButton(button)) === key) {
    updateWishlistButtonState(button);
  }
}

function displayWishlist() {
  const wishlistBlock = document.querySelector('.js-wishlistBlock');
  const emptyBlock = document.querySelector('.js-wishlistEmpty');

  if (!wishlistBlock) return;

  const wishlistData = getWishlist();

  if (wishlistData.length === 0) {
    wishlistBlock.innerHTML = '';
    emptyBlock?.classList.remove('hidden');
    return;
  }

  emptyBlock?.classList.add('hidden');

  const placeholder =
    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3C/svg%3E";

  wishlistBlock.innerHTML = wishlistData
    .map((item) => {
      const key = escapeHtml(itemKey(item));
      const title = escapeHtml(item.productTitle);
      const url = escapeHtml(item.productUrl);
      const img = escapeHtml(item.productImg || placeholder);
      const price = escapeHtml(item.productPrice);

      return `
        <div class="wishlist-page__item product-grid__item">
          <article class="wishlist-card card product-grid__card">
            <div class="wishlist-card__media">
              <a href="${url}" class="wishlist-card__image-link">
                <img
                  src="${img}"
                  alt="${title}"
                  class="wishlist-card__image"
                  loading="lazy"
                  width="600"
                  height="600"
                >
              </a>
              <button
                type="button"
                class="wishlist-card__remove button button-unstyled"
                data-wishlist-remove="${key}"
                aria-label="Favorilerden kaldır"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="wishlist-card__content">
              <h3 class="wishlist-card__title card__heading h5">
                <a href="${url}" class="full-unstyled-link">${title}</a>
              </h3>
              <div class="wishlist-card__price price">
                <span class="price">${price}</span>
              </div>
            </div>
          </article>
        </div>
      `;
    })
    .join('');

  wishlistBlock.querySelectorAll('[data-wishlist-remove]').forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      removeFromWishlist(btn.getAttribute('data-wishlist-remove'));
    });
  });
}

function initWishlist() {
  refreshAllWishlistButtons();
  updateWishlistCount();
  displayWishlist();
}

// Delegated click handling so the button works even when it's injected or
// re-rendered later (e.g. after a variant change re-renders the section).
document.addEventListener('click', (event) => {
  const button = event.target.closest('.wishlist_button');
  if (!button) return;
  // Buttons with a legacy inline onclick manage themselves; skip to avoid double toggling.
  if (button.hasAttribute('onclick')) return;
  event.preventDefault();
  toggleWishlist(button);
});

// Re-sync button states whenever a variant change replaces product markup.
document.addEventListener('variant:update', () => {
  requestAnimationFrame(() => {
    refreshAllWishlistButtons();
    updateWishlistCount();
  });
});

// Keep the count/buttons in sync across tabs and after bfcache restores.
window.addEventListener('storage', (event) => {
  if (event.key === WISHLIST_STORAGE_KEY) {
    refreshAllWishlistButtons();
    updateWishlistCount();
    displayWishlist();
  }
});

window.addEventListener('pageshow', () => {
  refreshAllWishlistButtons();
  updateWishlistCount();
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWishlist);
} else {
  initWishlist();
}

// Catch buttons added to the DOM after initial load and give them the correct state.
if (typeof MutationObserver !== 'undefined') {
  const wishlistObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.('.wishlist_button')) {
          updateWishlistButtonState(node);
        } else if (node.querySelector?.('.wishlist_button')) {
          node.querySelectorAll('.wishlist_button').forEach(updateWishlistButtonState);
        }
        if (node.matches?.('[data-wishlist-count]') || node.querySelector?.('[data-wishlist-count]')) {
          updateWishlistCount();
        }
      }
    }
  });

  const startObserving = () => wishlistObserver.observe(document.body, { childList: true, subtree: true });
  if (document.body) {
    startObserving();
  } else {
    document.addEventListener('DOMContentLoaded', startObserving);
  }
}

window.toggleWishlist = toggleWishlist;
window.removeFromWishlist = removeFromWishlist;
window.displayWishlist = displayWishlist;
window.refreshWishlistButtons = refreshAllWishlistButtons;
window.updateWishlistCount = updateWishlistCount;
